import * as React from "react"
import { Box } from "@mui/material";
import { MetricLoading, MetricTopLeft } from "./MetricComponents";
import ServiceOrderServiceWorkload from "../ServiceOrderServiceWorkload";

export default function ServiceOrderServiceWorkloadMetric({ selectedLocations, showLocationName = true }) {
    const [isLoading, setIsLoading] = React.useState(false)

    return (
        <React.Fragment>
            <Box sx={{ alignSelf: 'flex-start', width: '100%' }}>
                <h3>Service Orders Time To Work</h3>
            </Box>
            {selectedLocations.length > 0 && showLocationName &&
                <MetricTopLeft>{selectedLocations.length > 1 ? 'Multiple Locations' : selectedLocations?.[0]?.name}</MetricTopLeft>
            }
            <MetricLoading isLoading={isLoading} />
            <Box sx={{ display: isLoading ? 'none' : 'block', width: '100%' }}>
                <ServiceOrderServiceWorkload
                    selectedLocations={selectedLocations}
                    callbackLoading={setIsLoading}
                    showLocationName={false}
                    height={265}
                    breakout_locations={false}
                />
            </Box>
        </React.Fragment>
    )
}